import script from "./CategoryHierarchyForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./CategoryHierarchyForm.vue?vue&type=script&lang=ts&setup=true"

import "./CategoryHierarchyForm.vue?vue&type=style&index=0&id=884dc27e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-884dc27e"]])

export default __exports__